import React from 'react';
import { aboutData } from '../data/mock';
import { Check } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-20 md:py-28 bg-[#FAF9F7]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative z-10 img-zoom rounded-lg overflow-hidden shadow-2xl">
              <img
                src={aboutData.image}
                alt="Elite Marriage Lawns Venue"
                className="w-full h-[400px] md:h-[500px] object-cover"
              />
            </div>
            {/* Decorative Frame */}
            <div className="absolute -bottom-6 -right-6 w-full h-full border-2 border-[#C9A962] rounded-lg z-0" />
            {/* Experience Badge */}
            <div className="absolute -bottom-4 -left-4 md:left-8 bg-[#C9A962] text-white px-6 py-4 rounded-lg shadow-xl z-20">
              <p className="font-serif text-3xl md:text-4xl font-medium">10+</p>
              <p className="font-sans text-sm tracking-wider uppercase">Years of Excellence</p>
            </div>
          </div>

          {/* Content Side */}
          <div className="lg:pl-8">
            <span className="font-sans text-sm text-[#C9A962] tracking-[0.2em] uppercase mb-4 block">
              Welcome To
            </span>
            <h2 className="section-title text-left !mb-6 text-3xl md:text-4xl">
              {aboutData.title}
            </h2>
            <div className="decorative-line !mx-0 !mb-8" />
            <p className="text-[#6B6259] leading-relaxed mb-8 text-base md:text-lg">
              {aboutData.description}
            </p>

            {/* Features List */}
            <ul className="space-y-4 mb-8">
              {aboutData.features.map((feature, index) => (
                <li
                  key={index}
                  className="flex items-start gap-3"
                >
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#C9A962]/10 flex items-center justify-center mt-0.5">
                    <Check size={14} className="text-[#C9A962]" />
                  </span>
                  <span className="text-[#2C2C2C] font-medium">{feature}</span>
                </li>
              ))}
            </ul>

            {/* CTA */}
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="btn-primary inline-block text-sm"
            >
              Schedule a Visit
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
